export default __webpack_public_path__ + "38c9e34f85e2888d831ed54859b06c52.png";